"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateUpdateAppliedActivity = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const getRateUpdateAppliedActivityTableData_1 = require("../hooks/getRateUpdateAppliedActivityTableData");
const TableDisplay_1 = require("./TableDisplay");
const RateUpdateAppliedActivity = ({ activity }) => {
    const { columnNames, rows } = (0, getRateUpdateAppliedActivityTableData_1.getRateUpdateAppliedActivityTableData)(activity);
    return (0, jsx_runtime_1.jsx)(TableDisplay_1.TableDisplay, { columns: columnNames, rows: rows, isExpandable: true });
};
exports.RateUpdateAppliedActivity = RateUpdateAppliedActivity;
//# sourceMappingURL=RateUpdateAppliedActivity.js.map